import { useEffect } from "react";

import { launchSplash, type SplashController } from "./launchSplash";

/** Keep the launch splash up while `active` (no-op once it has gone). */
export const useSplashHold = (
  active: boolean,
  splash: SplashController | null = launchSplash,
): void => {
  useEffect(() => {
    if (!active || !splash) return;
    return splash.hold();
  }, [active, splash]);
};

/** The app has mounted: from now on the splash leaves once nothing holds it. */
export const useSplashStart = (
  splash: SplashController | null = launchSplash,
): void => {
  useEffect(() => {
    splash?.start();
  }, [splash]);
};
